import React from "react";
import AppStoreBadges from "../AppStoreBadges";
import "./InstructionCard.css";
import mobileSVG from "../../../assets/images/mobile.svg";

export interface InstructionCardProps {
  size?: "large" | "medium";
  layout?: "vertical" | "horizontal";
  title: string;
  descriptions?: string[];
  note?: string;
  iconSrc?: string;
  showStoreBadges?: boolean;
  alt?: string;
}

const InstructionCard: React.FC<InstructionCardProps> = ({
  size = "large",
  layout,
  title,
  descriptions = [],
  note,
  iconSrc,
  showStoreBadges = false,
  alt = "",
}) => {
  const isLarge = size === "large";
  const isMediumHorizontal = size === "medium" && layout === "horizontal";
  const useVerticalLayout = isLarge ? false : !isMediumHorizontal;

  return (
    <div className={`instruction-card ${size} ${isMediumHorizontal ? "instruction-card--medium-horizontal" : ""}`.trim()}>
      <div className={`instruction-card-content ${useVerticalLayout ? "vertical" : ""}`}>
        <div className={useVerticalLayout ? "instruction-text-vertical" : "instruction-text"}>
          {iconSrc && (
            <div className="instruction-icon-box">
              <img src={iconSrc} alt="" className="instruction-icon-img" />
            </div>
          )}
          <h2 className="instruction-title">{title}</h2>
          {descriptions.map((desc, i) => (
            <p key={i} className={isLarge ? "instruction-description" : "instruction-description-small"}>
              {desc}
            </p>
          ))}
          {note && <p className="instruction-note">{note}</p>}
          {showStoreBadges && <AppStoreBadges />}
        </div>
        <div className={useVerticalLayout ? "instruction-mockup-small" : "instruction-mockup instruction-mockup--medium"}>
          <img
            src={mobileSVG}
            alt={alt}
            className={useVerticalLayout ? "phone-mockup-small-img" : isLarge ? "phone-mockup-img" : "phone-mockup-small-img"}
          />
        </div>
      </div>
    </div>
  );
};

export default InstructionCard;
